<template>
    <b-row no-gutters class="border-light-grey py-1 py-sm-2 d-flex align-items-center">
        <b-col md="6">
            <b-row class="py-md-3">
                <b-col cols="12" sm="auto" class="d-flex justify-content-center justify-content-sm-start">
                    <div class="h3 mb-0 mr-2 ic-wrapper">
                        <b-link :to="arrowLink">
                            <SvgIcon name="arrow-left" :width="22" :height="22"/>
                        </b-link>
                    </div> <!-- arrow -->
                    <div class="dam-name mr-md-1 d-flex align-items-center">{{ currentDamSelectedName }}</div>
                </b-col>

                <b-col cols="12" sm="auto" class="d-flex justify-content-center justify-content-sm-start px-4">
                    <StatusDotText
                        :status-arr="currentDamSelectedStatus"
                        :large-dot="true"
                        :overflow-info="currentDamOverflowInfo"
                    ></StatusDotText>
                </b-col> <!-- /status wrapper -->
            </b-row>
        </b-col>
        <b-col
            v-if="isCameraButtonShown && ifHasCamera"
            md="6"
            class="d-flex justify-content-center justify-content-sm-end py-2 py-sm-0"
        >
            <WhiteIconButton
                icon="camera"
                :text="$t('sensors-page.camera')"
                :hide-text-mobile="true"
                :emit-this="'show-camera-modal'"
                v-on:show-camera-modal="showCameraModal"
            ></WhiteIconButton>

            <b-modal
                ref="camera-modal"
                size="lg"
                centered hide-footer no-close-on-esc
                header-class="border-bottom-0"
                :title="`${$t('sensors-page.camera-modal.camera')} - ${currentDamSelectedName}`"
            >
                <CameraModalBody></CameraModalBody>
            </b-modal>
        </b-col>
    </b-row>
</template>

<script>
    // mixins
    import RouteWatcher from "../../mixins/RouteWatcher";
    // utils
    import {mapGetters} from "vuex";
    // components
    import StatusDotText from "../shared/StatusDotText";
    import WhiteIconButton from "../shared/WhiteIconButton";
    import CameraModalBody from "./CameraModalBody";
    import SvgIcon from '../shared/SvgIcon';

    /**
     * First bar for sensors. Contains name, status, camera button,
     * show history button, modals are also here.
     * NOTE: modals are rendered at the bottom of the body tag, not here.
     */

    export default {
        name: "NameBar",
        mixins: [RouteWatcher],
        components: {
            StatusDotText,
            WhiteIconButton,
            CameraModalBody,
            SvgIcon
        },
        computed: {
            ...mapGetters([
                'currentDamSelectedName',
                'currentDamSelectedStatus',
                'currentDamOverflowInfo',
                'getHasCamera']),
            isCameraButtonShown() {
                return this.activeTab !== 5
            },
            ifHasCamera() {
                return this.getHasCamera;
            },
            arrowLink() {
                let backToObj = {name: 'dashboard'};
                if (this.$route.params.id) {
                    backToObj['params'] = {id: this.$route.params.id}
                }
                return backToObj;
            }
        },
        methods: {
            showCameraModal() {
                this.$refs['camera-modal'].show();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .border-light-grey {
        border-bottom: 1px solid $lightGrey;
    }

    .bi-arrow-left {
        color: $menuBlue;
        font-weight: bold;
        cursor: pointer;
    }

    .dam-name {
        text-align: left;
        font: normal normal 600 16px/22px Nunito, sans-serif;
        letter-spacing: 0px;
        color: $menuBlue;
        opacity: 1;
    }
</style>